import genericPoster from '../assets/posters/generic.webp';
import emergencyDepartmentPoster from '../assets/posters/emergency-department.webp';
import maternityPoster from '../assets/posters/maternity.webp';

const SOURCE_DIMENSIONS = Object.freeze({ width: 1449, height: 2048 });
const TRUST_LOGO_RECT = Object.freeze({ x: 925, y: 44, width: 455, height: 150, padding: 14 });
const GENERIC_LOGO_RECT = Object.freeze({ x: 878, y: 41, width: 480, height: 154, padding: 7 });

// Poster-specific QR placement follows the actual reserved boxes in each approved master.
// The renderer centres the QR (including its quiet zone) inside these bounds.
const GENERIC_QR_RECT = Object.freeze({ x: 107, y: 1377, width: 250, height: 249 });
const ED_QR_RECT = Object.freeze({ x: 96, y: 1366, width: 266, height: 268 });
const MATERNITY_QR_RECT = Object.freeze({ x: 93, y: 1380, width: 270, height: 265 });

export const PILOT_POSTER_TEMPLATES = Object.freeze([
  {
    id: 'generic',
    label: 'Generic ward / hospital poster',
    shortLabel: 'Generic poster',
    posterSrc: genericPoster,
    targetType: 'home',
    journeyId: null,
    qrLabel: 'Know Your Care home page',
    campaign: 'poster_generic',
    accent: '#0878e8',
    sourceDimensions: SOURCE_DIMENSIONS,
    logoRect: GENERIC_LOGO_RECT,
    qrRect: GENERIC_QR_RECT,
  },
  {
    id: 'emergency-department',
    label: 'Emergency Department poster',
    shortLabel: 'Emergency Department',
    posterSrc: emergencyDepartmentPoster,
    targetType: 'journey',
    journeyId: 'emergency-department',
    qrLabel: 'Emergency Department Journey',
    campaign: 'poster_ed',
    accent: '#d20b2a',
    sourceDimensions: SOURCE_DIMENSIONS,
    logoRect: TRUST_LOGO_RECT,
    qrRect: ED_QR_RECT,
  },
  {
    id: 'maternity',
    label: 'Maternity poster',
    shortLabel: 'Maternity',
    posterSrc: maternityPoster,
    targetType: 'journey',
    journeyId: 'maternity',
    qrLabel: 'Maternity Journey',
    campaign: 'poster_maternity',
    accent: '#0878e8',
    sourceDimensions: SOURCE_DIMENSIONS,
    logoRect: TRUST_LOGO_RECT,
    qrRect: MATERNITY_QR_RECT,
  },
]);

export const posterTemplateById = new Map(PILOT_POSTER_TEMPLATES.map((template) => [template.id, template]));
